import { Badge } from '@react-apps/design-system';
import type { BadgeProps } from '@react-apps/design-system';
import type { PendingAlertStatus } from '../../domain/entities/pending-alert.entity';

export function formatDateTime(iso: string | null | undefined): string {
  if (!iso) return '---';
  return new Intl.DateTimeFormat('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(new Date(iso));
}

export function Mono({ children }: { children: React.ReactNode }) {
  return <span className="break-all font-mono text-xs">{children}</span>;
}

type BadgeVariant = NonNullable<BadgeProps['variant']>;

/**
 * Só `open` chega na Central de Pendências (cada `PendingSource` já filtra em
 * `open` no fetch), mas o tipo cobre os três status genéricos por completude.
 */
const STATUS_VARIANT: Record<PendingAlertStatus, BadgeVariant> = {
  open: 'warning',
  resolved: 'success',
  dismissed: 'default',
};

export function PendingAlertStatusBadge({
  status,
  label,
}: {
  status: PendingAlertStatus;
  label: string;
}) {
  return <Badge variant={STATUS_VARIANT[status] ?? 'default'}>{label}</Badge>;
}

// --- Banners de feedback e erro de API — mesma paleta de `sales/presentation/shared/display.tsx`, ---
// --- duplicados aqui em vez de importados: `pending-alerts` agrega fontes, não depende de UI de uma delas. ---

/** Extrai uma mensagem legível de um erro de request (axios) ou Error genérico. */
export function getApiErrorMessage(err: unknown, fallback: string): string {
  if (err && typeof err === 'object') {
    const maybe = err as {
      response?: { data?: { message?: unknown } };
      message?: unknown;
    };
    const apiMsg = maybe.response?.data?.message;
    if (typeof apiMsg === 'string') return apiMsg;
    if (Array.isArray(apiMsg) && typeof apiMsg[0] === 'string')
      return apiMsg[0];
    if (typeof maybe.message === 'string') return maybe.message;
  }
  return fallback;
}

export function ErrorBanner({ message }: { message: string }) {
  return (
    <div className="rounded-lg bg-red-50 p-3 text-sm text-red-700 dark:bg-red-950/40 dark:text-red-300">
      {message}
    </div>
  );
}

export function SuccessBanner({ message }: { message: string }) {
  return (
    <div className="rounded-lg bg-green-50 p-3 text-sm text-green-700 dark:bg-green-950/40 dark:text-green-300">
      {message}
    </div>
  );
}
